import { render, staticRenderFns } from "./foot copy.vue?vue&type=template&id=468b9ae8"
import script from "./foot copy.vue?vue&type=script&lang=js"
export * from "./foot copy.vue?vue&type=script&lang=js"
import style0 from "./foot copy.vue?vue&type=style&index=0&id=468b9ae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports